import { useState } from 'react';
import { useAppSelector } from '@/redux/hooks';
import { showDemoDataSelectors } from '@/redux/selectors';

import { ThisIsDemoData } from '../ThisIsDemoData';
import { BehavioralAlerts } from '../BehavioralAlerts/BehavioralAlerts';
import TransactionAlerts from '../TransactionAlerts/TransactionAlerts';
import AlertsSettingsNavTabs from './components/AlertsSettingsNavTabs/AlertsSettingsNavTabs';
import { AlertsSettingsNavTabsKeys } from './components/AlertsSettingsNavTabs/AlertsSettingsNavTabs.constants';
import styles from './AlertSettings.module.sass';

const AlertsSettings = (): JSX.Element => {
  const isShowDemoData = useAppSelector(showDemoDataSelectors.byCompliance);
  const [tab, setTab] =
    useState<AlertsSettingsNavTabsKeys>('behavioral-alerts'); // transaction-alerts

  return (
    <div className={styles.alertsSettings}>
      {isShowDemoData && <ThisIsDemoData />}

      <AlertsSettingsNavTabs tab={tab} onChange={setTab} />

      {tab === 'transaction-alerts' && (
        <TransactionAlerts isShowDemoData={isShowDemoData} />
      )}

      {tab === 'behavioral-alerts' && (
        <BehavioralAlerts isShowDemoData={isShowDemoData} />
      )}
    </div>
  );
};

export default AlertsSettings;
